import {
	AvatarProps,
	Box,
	Flex,
	FlexProps,
	useColorModeValue,
	Image,
	Center,
} from "@chakra-ui/react";
import { Mob } from "../../../types/mob";
import { Raider } from "../../../types/raider";

interface CardWithAvatarProps extends FlexProps {
	avatarProps: AvatarProps & { raider?: Raider,  mob?: Mob};
}

export const CardWithAvatar = (props: CardWithAvatarProps) => {
	const { children, avatarProps, ...rest } = props;

	return (
		<Flex
			direction="column"
			alignItems="center"
			rounded="md"
			padding="8"
			position="relative"
			bg={useColorModeValue("white", "gray.700")}
			shadow={{ md: "base" }}
			{...rest}
		>
			<Box
				position="absolute"
				inset="0"
				height="20"
				bg="blue.600"
				roundedTop="inherit"
			/>
			<Box size="xl" zIndex={1} className="avatar-preview">
				<Center width="14rem" height="14rem">
					<Image
						loading="lazy"
						width="224"
						height="224"
						src={avatarProps.raider ? avatarProps.raider.image : avatarProps.mob?.image}
						alt="Raider"
					/>
					{/* <Text>
						{avatarProps.raider ? avatarProps.raider.image : "nothing"}
					</Text> */}
				</Center>
			</Box>
			{children}
		</Flex>
	);
};
